const headTitleList: any[] = [
  {
    headTitle: "申請者",
  },
  {
    headTitle: "申請・届出名",
  },
  {
    headTitle: "申請日時",
  },
  {
    headTitle: "状況",
  },
  {
    headTitle: "担当者名",
  },
];

const headTitleList2: any[] = [
  {
    headTitle: "関連帳票",
    align: "left",
  },
  {
    headTitle: "記号番号",
    align: "left",
  },
  {
    headTitle: "決裁日",
    align: "left",
  },
];

const downloadFile = [
  {
    fileName: "掛金の返還請求決定通知について（通知文差込データ用）",
    formClass: "EXP0402033",
    businessType: "JOB-86",
    status: "08",
    fileBase64: "",
  },
  {
    fileName: "施設等新設届・申出書・（別紙）施設等新設届・申出書職員名簿",
    formClass: "EXP0201007",
    businessType: "JOB-92",
    status: "",
    fileBase64: "",
  },
  {
    fileName: "退職手当金振込先金融機関変更届",
    formClass: "EXP0801006",
    businessType: "JOB-91",
    status: "",
    fileBase64: "",
  },
  {
    fileName: "退職手当金支給予定調書",
    formClass: "EXP0704027",
    businessType: "JOB-67",
    status: "",
    fileBase64: "",
  },
  {
    fileName: "源泉徴収税内訳表",
    formClass: "EXP0704204",
    businessType: "JOB-67",
    status: "08",
    fileBase64: "",
  },
  {
    fileName: "遺族請求明細書",
    formClass: "EXP0704207",
    businessType: "JOB-67",
    status: "",
    fileBase64: "",
  },
  {
    fileName: "市町村民税・道府県民税納付書",
    formClass: "RPT0703041",
    businessType: "JOB-67",
    status: "08",
    fileBase64: "",
  },
  {
    fileName: "退職手当金支給決定調書",
    formClass: "EXP0704028",
    businessType: "JOB-67",
    status: "08",
    fileBase64: "",
  },
  {
    fileName: "退職手当金等受給者別支払調書",
    formClass: "EXP0704044",
    businessType: "JOB-67",
    status: "08",
    fileBase64: "",
  },
  {
    fileName: "退職手当金振込先金融機関変更届について（差込データ用）",
    formClass: "EXP0802035",
    businessType: "JOB-90",
    status: "",
    fileBase64: "",
  },
  {
    fileName: "退職手当金の送金時期について（差込データ用）",
    formClass: "EXP0802037",
    businessType: "JOB-67",
    applyType: "JOB-77",
    status: "",
    fileBase64: "",
  },
  {
    fileName: "掛金の返還請求決定通知について（通知文差込データ用）",
    formClass: "EXP0402033",
    businessType: "JOB-72",
    status: "08",
    fileBase64: "",
  },
];

const navigatePath = {
  "JOB-14": "/SCRW160007",
  "JOB-15": "/SCRW070003",
  "JOB-35": "/SCRW410001",
  "JOB-39": "/SCRW410006",
  "JOB-42": "/SCRW070004",
  "JOB-43": "/SCRW070004",
  "JOB-68": "/SCRW160009",
  "JOB-70": "/SCRW410006",
  "JOB-75": "/SCRC070105",
  "JOB-77": "/SCRW410001",
} as { [key: string]: string };

export { headTitleList, downloadFile, headTitleList2, navigatePath };
